import React, {useState, useEffect} from 'react';
import {redirectToSameWindowWithRefresh, getCrid} from '../../../../../utils/redirectWithCrId';

import * as S from './Aside.styles';

const Aside = ({onMenuSelect, menuSelectPage, onlyGST, sendTrackingDataToSdk}) => {
  const [subMenuSelect, setSubMenu] = useState(3);
  const [menuSelect, setMenu] = useState(1);

  useEffect(() => {
    if (menuSelectPage === 'trackGSTInputCredit') {
      setSubMenu(5);
    }
  }, [menuSelectPage]);

  const handleSubMenuSelect = (index, subMenuName, e) => {
    e.stopPropagation();
    setSubMenu(index);
    onMenuSelect(subMenuName);
  };
  const handleMenuSelect = (index, e) => {
    e.preventDefault();
    setMenu(index);
    if (index === 0) {
      setSubMenu(0);
      onMenuSelect('transactionReport');
    } else {
      setSubMenu(3);

      onMenuSelect('gstCommissionInvoice');
    }
  };

  return (
    <S.Aside>
      <div
        open={menuSelect === 0}
        onClick={() => {
          redirectToSameWindowWithRefresh('/agent/transactionreport');
        }}
      >
        {!onlyGST && (
          <p className={`headTitle`}>
            <span className="reportSprite reportIcon"></span> Reports
          </p>
        )}
        {menuSelect === 0 && (
          <ul>
            <li
              className={`${subMenuSelect == 0 ? 'active' : ''}`}
              onClick={e => handleSubMenuSelect(0, 'transactionReport', e)}
            >
              Transaction Report
            </li>
            <li
              className={`${subMenuSelect == 1 ? 'active' : ''}`}
              onClick={e => handleSubMenuSelect(1, 'commissionReport', e)}
            >
              Commission Report
            </li>
            <li
              className={`${subMenuSelect == 2 ? 'active' : ''}`}
              onClick={e => handleSubMenuSelect(2, 'tdsCertificate', e)}
            >
              TDS Certificate
            </li>
          </ul>
        )}
      </div>
      <div open={menuSelect === 1} onClick={e => handleMenuSelect(1, e)}>
        <p className={`headTitle`}>
          <span className="reportSprite gstIcon"></span> GST Invoice
        </p>
        {menuSelect === 1 && (
          <ul>
            <li
              className={`${subMenuSelect == 3 ? 'active' : ''}`}
              onClick={e => {
                handleSubMenuSelect(3, 'gstCommissionInvoice', e);
                sendTrackingDataToSdk?.(
                  {
                    event_detail: {
                      event_name: 'click',
                      event_type: 'user_action',
                      event_value: 'Download GST Commission Invoice Section Clicked',
                    },
                  },
                  'GST_INVOICE_REPORT',
                );
              }}
            >
              Download GST Commission Invoice
            </li>
            <li
              className={`${subMenuSelect == 4 ? 'active' : ''}`}
              onClick={e => {
                handleSubMenuSelect(4, 'submitGSTInput', e);
                sendTrackingDataToSdk?.(
                  {
                    event_detail: {
                      event_name: 'click',
                      event_type: 'user_action',
                      event_value: 'Submit GST Input Section Clicked',
                    },
                  },
                  'GST_INVOICE_REPORT',
                );
              }}
            >
              Submit GST Input
            </li>
            <li
              className={`${subMenuSelect == 5 ? 'active' : ''}`}
              onClick={e => {
                handleSubMenuSelect(5, 'trackGSTInputCredit', e);
                sendTrackingDataToSdk?.(
                  {
                    event_detail: {
                      event_name: 'click',
                      event_type: 'user_action',
                      event_value: 'Track GST Input Credit Clicked',
                    },
                  },
                  'GST_INVOICE_REPORT',
                );
              }}
            >
              Track GST input Credit
            </li>
          </ul>
        )}
      </div>
    </S.Aside>
  );
};

export default Aside;
